module.exports = __webpack_public_path__ + "img/bridge-circle.fad41b51.svg";